import { IExtraLogs } from './extra-logs.interface';
import { ScoreConfig } from './score-config.interface';
import { LogTypesEnum } from '../enums';

export interface ITripLogOutputDto {
    id?: string;
    trip: string;
    message: string;
    datetime?: string;
    source?: string;
    organizationId?: string;
    createdBy?: string;
    createdByUserId?: string;
    createdAt?: string;
    type?: LogTypesEnum;
    seenBy?: string[];
    extra?: IExtraLogs;
}

export interface IScoreConfigAuditLogOutputDto {
    id?: string;
    organizationId?: string;
    message: string;
    datetime?: string;
    createdBy?: string;
    createdAt?: string;
    type?: LogTypesEnum;
    extra?: IExtraLogs;
}

export interface ICreateScoreConfigAuditLogDto {
    createdBy: string;
    tripDefinitionId?: string;
    action: 'update';
    previousConfig: ScoreConfig;
    updatedConfig: ScoreConfig;
}
